// ThemePage — dev-only living style guide. Renders the design tokens and every
// component the shared library exports; flips with the app's light/dark toggle
// and RTL. Sections mirror the design board's numbered groups.

import { useTranslation } from 'react-i18next';
import FoundationsSection from './FoundationsSection';
import ActionsSection from './sections/ActionsSection';
import FormsSection from './sections/FormsSection';
import DataDisplaySection from './sections/DataDisplaySection';
import OverlaysNavSection from './sections/OverlaysNavSection';

const ThemePage = () => {
  const { t } = useTranslation();

  return (
    <div className='theme-page'>
      <header className='theme-page__header'>
        <h1 className='theme-page__title'>{t('theme_page_title')}</h1>
        <p className='theme-page__subtitle'>{t('theme_page_subtitle')}</p>
      </header>
      <FoundationsSection />
      <ActionsSection />
      <FormsSection />
      <DataDisplaySection />
      <OverlaysNavSection />
    </div>
  );
};

export default ThemePage;
